/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCatalogItemDto
 */
export interface CreateCatalogItemDto {
    /**
     * Product ID to add to catalog
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    productId: number;
    /**
     * Price for this product in the catalog
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    price: number;
    /**
     * Currency for the price
     * @type {string}
     * @memberof CreateCatalogItemDto
     */
    currency: CreateCatalogItemDtoCurrencyEnum;
    /**
     * Minimum order quantity
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    minimumOrderQty?: number;
    /**
     * Maximum order quantity
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    maximumOrderQty?: number;
    /**
     * Whether the product is in stock
     * @type {boolean}
     * @memberof CreateCatalogItemDto
     */
    inStock?: boolean;
    /**
     * Stock quantity available (null = unlimited, 0 = out of stock)
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    stockQuantity?: number;
    /**
     * Description of the catalog item
     * @type {string}
     * @memberof CreateCatalogItemDto
     */
    description?: string;
    /**
     * Lead time for the product in days
     * @type {number}
     * @memberof CreateCatalogItemDto
     */
    leadTime?: number;
    /**
     * Time-based order limit (DAY, WEEK, or MONTH)
     * @type {object}
     * @memberof CreateCatalogItemDto
     */
    orderLimit?: object;
}


/**
 * @export
 */
export const CreateCatalogItemDtoCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type CreateCatalogItemDtoCurrencyEnum = typeof CreateCatalogItemDtoCurrencyEnum[keyof typeof CreateCatalogItemDtoCurrencyEnum];


/**
 * Check if a given object implements the CreateCatalogItemDto interface.
 */
export function instanceOfCreateCatalogItemDto(value: object): value is CreateCatalogItemDto {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function CreateCatalogItemDtoFromJSON(json: any): CreateCatalogItemDto {
    return CreateCatalogItemDtoFromJSONTyped(json, false);
}

export function CreateCatalogItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCatalogItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'price': json['price'],
        'currency': json['currency'],
        'minimumOrderQty': json['minimumOrderQty'] == null ? undefined : json['minimumOrderQty'],
        'maximumOrderQty': json['maximumOrderQty'] == null ? undefined : json['maximumOrderQty'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'stockQuantity': json['stockQuantity'] == null ? undefined : json['stockQuantity'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['leadTime'] == null ? undefined : json['leadTime'],
        'orderLimit': json['orderLimit'] == null ? undefined : json['orderLimit'],
    };
}

export function CreateCatalogItemDtoToJSON(value?: CreateCatalogItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'productId': value['productId'],
        'price': value['price'],
        'currency': value['currency'],
        'minimumOrderQty': value['minimumOrderQty'],
        'maximumOrderQty': value['maximumOrderQty'],
        'inStock': value['inStock'],
        'stockQuantity': value['stockQuantity'],
        'description': value['description'],
        'leadTime': value['leadTime'],
        'orderLimit': value['orderLimit'],
    };
}

